import { useOutletContext } from 'react-router-dom';
import { MobileNotificationsContextType } from '../mobile-notifications';
import { NotificationsList } from '../notifications-list/notifications-list';

export const MobileNotificationsStaff = () => {
  const { handleRemoveNotification, notifications, isLoading } =
    useOutletContext<MobileNotificationsContextType>();

  if (isLoading) return null;

  const filteredNotifications = notifications.filter((item) =>
    ['delay', 'possible_delay', 'serious_delay'].includes(item.type),
  );

  return (
    <NotificationsList
      notifications={filteredNotifications}
      handleRemoveNotification={handleRemoveNotification}
    />
  );
};
